import { Component, ChangeDetectionStrategy, effect, inject, input } from '@angular/core';
import { ReportInfo, ReportRecord, ReportView, TemplateProjectionMap } from '../../../../models/report.model';
import { TemplateField } from '../../../../models/template.model';
import { GroupBase } from '../../../../models/blueprint.model';
import { EditableFieldsService } from '../../../editable-fields.service';
import { NgTemplateOutlet, NgClass, AsyncPipe } from '@angular/common';
import { ReportFieldFormatterPipe } from '../../../../shared/pipes/report-field-formatter.pipe';
import { SelectTemplateOutletPipe } from '../../../../shared/pipes/select-template-outlet.pipe';
import { ReportFieldRouteFnPipe } from '../../../../shared/pipes/report-field-route-fn.pipe';
import { IsFieldVisiblePipe } from '../../../../shared/pipes/field-visible.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-presentation-dynamic-view-header',
  templateUrl: './record-header.component.html',
  styleUrl: './record-header.component.scss',
  imports: [
    NgTemplateOutlet,
    NgClass,
    AsyncPipe,
    ReportFieldFormatterPipe,
    SelectTemplateOutletPipe,
    ReportFieldRouteFnPipe,
    IsFieldVisiblePipe
],
})
export class PresentationDynamicViewHeaderComponent {
  public editableFieldsService = inject(EditableFieldsService);

  readonly reportRecordData = input.required<ReportRecord>();
  readonly reportData = input.required<ReportInfo>();
  readonly currentView = input.required<ReportView>();
  readonly headerGroups = input.required<GroupBase<TemplateField>[]>();
  readonly templateProjectionMap = input.required<TemplateProjectionMap>();
  titleGroup: GroupBase<TemplateField>;
  attributesGroup: GroupBase<TemplateField>;

  constructor() {
    effect(() => {
      const headerGroups = this.headerGroups();
      if (!!headerGroups) {
        const [titleGroup, attributesGroup] = headerGroups;
        this.titleGroup = titleGroup;
        this.attributesGroup = attributesGroup;
      }
    });
  }
}
